import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchApplications } from "services/api/application";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { Application, ApplicationsReducerState } from "types/application";
import { getErrorMessage, isFresh } from "utils/helpers";

export const fetchApplicationsThunk = createAsyncThunk<{applications: Application[], count: number}, {force: boolean}>(
    'applications/fetchApplications',
    async ({force=false}, {getState, rejectWithValue}) => {
        const state = getState() as {applications: ApplicationsReducerState, auth: AuthState};
        if(!state.auth.selectedHubId){
            return rejectWithValue(ERROR.NOT_FOUND)
        }
        const STALE_TIME = apiConfig.FETCH_APPLICATIONS.staleTime
        try {
            if(!force && isFresh(state.applications.last_fetched_at, STALE_TIME)){
                return rejectWithValue(ERROR.CACHED)
            }
            const {items: applications, count} = await fetchApplications(state.auth.selectedHubId, {page: 1, limit: 500});
            return {applications: applications, count: count};
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, ERROR.NOT_FOUND));
        }
    }
)